import { connect } from 'react-redux'
import Export from './Export.component'
import * as Actions from 'state/actions'

const mapStateToProps = state => {
  return {
    isRequesting: state.analyticsExport.isRequesting,
    isLoadingExports: state.analyticsExport.isLoadingExports,
    exports: state.analyticsExport.exports,
    agentId: state.agent?.active?.agentId,
    exportFailed: state.analyticsExport.exportFailed,
    exportSuccess: state.analyticsExport.exportSuccess
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onExportV2: ({ dateRange, fileFormat }) => dispatch(Actions.exportAnalyticsV2({ dateRange, fileFormat })),
    onLoadExports: () => dispatch(Actions.loadExports()),
    saveConfig: () => {
      dispatch(Actions.saveReportingConfig())
      dispatch(Actions.saveExportApiConfig())
    },
    onCloseExportErrorModal: () => dispatch(Actions.closeExportErrorModal())
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Export)
